module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GC2jEn/tc-custom/9781504089531.jpg?1708750477007",
      "alt": "This image is the cover for the book Murders at the Rookery Grange Retreat, The Prunella Pearce Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murders at the Rookery Grange Retreat, The Prunella Pearce Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Residents of a rest home are dying of very unnatural causes, in this new novel in a series of “warm, cozy crime capers” ("), _c('i', [_vm._v("Jill’s Book Cafe")]), _vm._v(").")]), _c('br'), _c('br'), _c('i', [_vm._v("Christmas Eve, 1989. ")]), _vm._v("A couple is found slumped in front of their twinkling Christmas tree in an apparent murder-suicide . . ."), _c('br'), _c('br'), _c('i', [_vm._v("Today")]), _vm._v(". Librarian Pru Pearce is preparing for her wedding to police detective Andy Barnes. But after one of her Women’s Institute friends suffers a suspicious accident at Rookery Grange, a home for the elderly and infirm, Pru and the other ladies are on alert. And when one of the residents is asphyxiated with a pillow, no one can rest easy . . ."), _c('br'), _c('br'), _vm._v(" With her wedding taking a disastrous turn and a killer on the loose, the part-time detective makes another vow: to investigate and solve the mystery. Will she unravel generations of murderous secrets and find the culprit?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gina Kirkham\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0